/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-11-14 09:25:32
 */

import DataView from "../dataView";
import {IconBtnItem} from "src/components/iconBtnGroup/iconBtnGroup";
import {ColDefCustom, default as AgGridVueCustomTsx} from "src/components/agGridCustom/agGridVueCustomTsx";
import DataViewApi,{DataViewDOI} from "../api/dataViewApi";
import _ from 'lodash'
import ListPageService from 'src/types/ListPage';
import override from "src/dectorators/override";
import {QueryFormVOI} from "src/components/queryForm/queryForm";
import Input from 'src/types/iview/Input';
import EnumStationType from 'src/enums/enumStationType';
import CellRenderTsx from 'src/components/agGridComponent/cellRenderTsx';
import RouteUtils from 'src/util/routeUtils';
import { createNamespace } from 'src/util/bem';
import {DateTimeUtil} from 'src/util/dateTimeUtil';

export default class DataViewService extends ListPageService {
    ctx: DataView;
    
    get type() {
        return EnumStationType.findCode(this.ctx.$route.params.type).getId();
    }

	constructor (ctx: DataView) {
	    super()
		this.ctx = ctx
	}

    @override
	createColumns (): ColDefCustom [] {
		let t = this
		return [
			{
				headerName: '站点名称',
				field: 'device_name',
				minWidth: 200,
                cellRendererFramework: CellRenderTsx,
                cellRendererFrameworkOpt: {
                    cellRender(h, params) {
                        let data: DataViewDOI.RowDataI = params.data;
                        return (
                            <div
                                class={createNamespace('cursor link')}
                                on-click={()=> {
                                    var is_auto_audit = data.is_auto_audit;
                                    RouteUtils.goToWidthCache(`/${t.ctx.$route.params.type}/dataManage/dataView/detail`, { mn: data.MN,productId: data.product_id,name: data.device_name,id: data.id, cn: t.ctx.currentDataType, is_auto_audit: is_auto_audit == undefined ? 1 : is_auto_audit });
                                }}
                            >
                                {data.device_name}
                            </div>
                        );
                    },
                },
			},
			{
				headerName: '时间',
				field: 'DateTime',
				minWidth: 170,
                cellRendererFramework: CellRenderTsx,
                cellRendererFrameworkOpt: {
                    cellRender(h, params) {
                        let data: DataViewDOI.RowDataI = params.data;
                        return (
                            DateTimeUtil.formateDate(data.DateTime)
                        );
                    },
                },
			},
		]
	}

    @override
	createBtnGroup (): Array<IconBtnItem> {
		return []
	}

    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            {
                component: Input,
                label: '',
                field: 'device_name',
                width: 300,
                props: { value: '', placeholder: '请输入站点名称' },
            },
        ];
    }


	@override
	initSearchParams (): void {
		this.ctx.searchParams = {
            ...this.ctx.queryForm.getQueryObj<DataViewDOI.QueryRowDataParamsI>(),
            type: this.type,
            cn: this.ctx.currentDataType
        
        }
		this.ctx.currentPage = 1
	}

    @override
	async searchTable () {
		let ctx = this.ctx
		let ag = (this.ctx.$refs.ag) as AgGridVueCustomTsx
		ag.showLoading()
		let {code, data} = await DataViewApi.searchList({
			...ctx.searchParams
		})
		ag.hideLoading()

		if (code === 0) {
			ctx.columnDefs = [
                ...this.createColumns(),
                ...data.header.map(i => ({
                    headerName: `${i.name}(${i.unit})`,
                    field: i.key,
                    minWidth: 100,
                })),
            ];
            ctx.rowData = data.data_info || [];
            
		}
    }
    
    async queryDataType() {
        let {data, code} = await DataViewApi.searchDataType()
        if(code === 0) {
            if(this.type != 2){
                this.ctx.dataType = data.map(i=> ({name: i.data_name, value: i.cn}))
                this.ctx.currentDataType = data[0].cn
            }
            else{
                data.forEach(i => {
                    if(i.cn == "2082")
                    {
                        this.ctx.dataType.push({name: i.data_name, value: i.cn});
                    }
                });
                this.ctx.currentDataType = "2082"
            }
            // 新增手工数据 (cn=11000)，三个路由类型通用
            this.ctx.dataType.push({name: '手工数据', value: '11000'})
        }
    }

}